import React, { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { HOST } from "../../host";
import { GlobalContext } from "../../../App";
import L from "leaflet";
import { logToServer } from "../../logger";
import { Modal } from "react-bootstrap";
function Upload() {
  const [show, setshow] = useState(false);
  const [file, setFile] = useState(null);
  const [mess, setMess] = useState(null);
  const [color, setColor] = useState(null);
  const [fill, setFill] = useState(false);
  // const [name, setName] = useState(null);
  const [id, setId] = useState(null);
  const [add, SetAdd] = useState(false);
  const [loader, setLoader] = useState(false);
  const [bounds, setBounds] = useState(null);
  const [aPro, setPro] = useState(false);
  const [pro, setSelPro] = useState("");
  const [path, setPath] = useState(null);
  const [type, setType] = useState(null);
  const [column, setColumn] = useState([]);
  // const [selectedcolumn, setselectedcolumn] = useState([])
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [csv, setCsv] = useState(false);
  const [file_path, setfile_path] = useState(null);
  const [parent, setParent] = useState(null);
  const [per, setPer] = useState(null);
  const exclude = [
    "Panvel",
    "panvel",
    "survey",
    "Jeevit",
    "Agrani",
    "Malegaon",
    "Manyad",
    "Pune",
    "Waterbody-Collection",
    "pune-demo",
    "satara",
    "Raigad-Landslide-Hazard-Assesment",
    "Kolhapur-Flood-Assesment",
    "Water-Impact-of-water-on-Agri-&-Livestock",
    "Kolhapur-Forest-Fire-Assesment",
    "Avalpoondurai-Crop-Classification",
    "Assam-Flood-2023",
    "Mines-in-Meghalaya",
    "Barpeta",
  ];
  const {
    vis, name, setName,
    rastName, setRastName,
    Canvas,
    layerControls,
    userInfo,
    userProjects,
    organizationProjects,
    setOrganizationProjects,
    setUserProjects,
    map,
    selTab,
    getCsrfToken,
    bbox, setBbox,
    setGlobalMinValue, setGlobalMaxValue,
    globalMinValue,
    globalMaxValue,
    setGeoLayerName,
    setGeoWorkspace,
  } = useContext(GlobalContext);
  const toolvisRef = useRef(null);
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);

  const toggleModal = () => setShowModal(!showModal);

  const [eventSource, setEventSource] = useState(null);

  async function sendAct() {
    let data = {};
    if (window.location.pathname.startsWith("/project/")) {
      const projectId = window.location.pathname.split("/")[3];
      data["project"] = projectId;
    } else {
      data["project"] = "global";
    }
    data["memb"] = userInfo.id;
    data["tab"] = selTab;
    data["id"] = name;
    data["type"] = type;
    data["pro"] = pro;
    data["bounds"] = bounds;
    data["path"] = path;
    data["add"] = aPro;
    data["color"] = color;  
    data["fill"] = fill;  
    try {
      const response = await fetch(`${HOST}/upload-act`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": await getCsrfToken(),
        },
        body: JSON.stringify({ data }),
      });
      if (!response.ok) {
        logToServer("error", "failed to send draw data");
        throw new Error("Failed to send draw data");
      }
      const responseData = await response.json();
      logToServer("info", "send Draw data");
      return responseData;
    } catch (error) {
      logToServer("error", `Error occurred while sending draw data:${error}`);
      throw error;
    }
  }

  async function AddLayertoPro() {
    if (pro && pro !== "") {
      setLoader(true);
      try {
        const res = await fetch(`${HOST}/layer-to-pro`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": await getCsrfToken(),
          },
          body: JSON.stringify({
            data: {
              name: name,
              id: id,
              bounds: bounds,
              type: type,
              project: pro,
              user: userInfo.id,
              path: path,
              color: color,
              fill: fill,
            },
          }),
        });
       console.log('data',res)
        if (res.status === 400) {
          alert("Layer Not added");
          setLoader(false);
          logToServer("error", "Layer Not added to project");
          return false;
        } else if (res.status === 200) {
          alert("Layer added Successfully");
          logToServer("info", "Layer added successfully to project");
          setLoader(false);
          const projectId = location.pathname.split("/")[3];
          if (projectId) {
            const event = new Event("added-to-pro");
            document.dispatchEvent(event);
          }

          return true;
        }
      } catch (e) {
        setLoader(false);
        logToServer(
          "error",
          `Unexpected error while adding layer to project: ${e}`
        );
        alert("Unexpected error occured. Please try again");
      }
    } else {
      alert("Please select a project");
      return false;
    }
  }
  async function deletePath(path) {
    await fetch(`${HOST}/delete-objects`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ data: { path: path } }),
    });
  }
  // useEffect(() => {

  //   let paths = sessionStorage.getItem('path');
  //   if (paths) {
  //     paths = JSON.parse(paths);
  //     if (Array.isArray(paths)) {
  //       sessionStorage.removeItem('path');
  //       deletePath(paths)
  //     }
  //   }
  // }, [])
  function AddLayer() {
    const savedPath = sessionStorage.getItem("path");
    if (savedPath) {
      sessionStorage.removeItem("path");
    }
    if (aPro) {
      if (!AddLayertoPro()) {
        return;
      }
    }
    SetAdd(false);
    setMess(null);
    const projectExists =
      userProjects.some(
        (project) => project.id === location.pathname.split("/")[3]
      ) ||
      organizationProjects.some(
        (project) => project.id === location.pathname.split("/")[3]
      );
    sendAct().then((result) => {
      if (projectExists && aPro) {
        setPro(false);
        setSelPro("");
        return;
      }
      setPro(false);
      setSelPro("");
      if (type === "vector") {
        let layer_col = color ? color : "#000000";
        Canvas.addLayer(name, id, layer_col, fill, true, bounds);
        layerControls.addOverlay(
          L.geoJSON(),
          id,
          true,
          bounds,
          true,
          name,
          false,
          result.parent
        );
      } else {
        const minLat = bounds[0][0];
        const minLon = bounds[0][1];
        const maxLat = bounds[1][0];
        const maxLon = bounds[1][1];

        const polygonCoordinates = [
          [minLon, minLat],
          [maxLon, minLat],
          [maxLon, maxLat],
          [minLon, maxLat],
          [minLon, minLat],
        ];
        const latLngBounds = L.latLngBounds([minLat, minLon], [maxLat, maxLon]);
        const geojsonPolygon = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [polygonCoordinates],
              },
              properties: {},
            },
          ],
        };
        let layer = L.TileLayer.boundaryCanvas(
          `https://geoserver.vasundharaa.in/geoserver/useruploads/gwc/service/wmts?layer=useruploads:${name}&style=&tilematrixset=EPSG%3A900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image%2Fjpeg&TileMatrix=EPSG%3A900913%3A{z}&TileCol={x}&TileRow={y}`,
          {
            boundary: geojsonPolygon,
            zIndex: 1000,
            bounds: latLngBounds,
            maxZoom: 20,
          }
        );

        layerControls.addOverlay(
          layer,
          id,
          false,
          false,
          false,
          false,
          false,
          result.parent
        );
        layer.addTo(map);
        map.flyToBounds(bounds);
      }

      // deletePath(path)
      logToServer("info", "Layer added successfully");
    });
  }

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // const listenForUpdates = () => {
  //   const es = new EventSource(`${HOST}/sse/updates/${userInfo.id}`);
  //   setEventSource(es);

  //   es.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     if (
  //       data.message === "success" ||
  //       data.message === "csv" ||
  //       data.message === "sld"
  //     ) {
  //       setLoader(false);
  //       handleFinalResponse(data);
  //       es.close();
  //     }
  //   };
  //   es.onerror = (error) => {
  //     console.error("EventSource failed:", error);
  //     setMess("An error occurred while receiving updates.");
  //     es.close();
  //   };
  // };

  const listenForUpdates = () => {
    const intervalId = setInterval(() => {
      fetch(`${HOST}/sse/updates/${userInfo.id}`)
        .then((response) => response.json())
        .then((data) => {
          if (
            data.message === "success" ||
            data.message === "csv" ||
            data.message === "sld"
          ) {
            setLoader(false);
            handleFinalResponse(data);
            clearInterval(intervalId); // Stop the interval once we get the desired response
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          clearInterval(intervalId); // Stop the interval if there is an error
        });
    }, 5000); // Check every 5 seconds
  };

  const handleUpload = async () => {
    setMess(null);
    setBounds(null);
    SetAdd(false);
    setLoader(true);
    const CHUNK_SIZE = 50 * 1024 * 1024; // 50MB
    console.log("CHUNK_SIZE", CHUNK_SIZE);
    if (!file) {
      alert("No file selected.");
      return;
    }
    let styleName = null;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    console.log("totalChunks", totalChunks);
    if (file.name.split(".").pop().toLowerCase() === "sld") {
      styleName = prompt("Enter Style Name:");
      if (!styleName) {
        alert("Style name is required.");
        return;
      }
    }
    try {
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        setPer(Math.round((chunkIndex / totalChunks) * 100));
        const start = chunkIndex * CHUNK_SIZE;
        const end = Math.min(file.size, start + CHUNK_SIZE);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("chunk", chunk);
        formData.append("chunkIndex", chunkIndex);
        formData.append("totalChunks", totalChunks);
        formData.append("fileName", file.name);
        console.log('filenamegeo', file.name)
        if (file.name.split(".").pop().toLowerCase() === "sld") {
          formData.append("name", styleName);
        }

        const response = await fetch(`${HOST}/upload/${userInfo.id}`, {
          method: "POST",
          credentials: "include",
          headers: {
            "X-CSRFToken": await getCsrfToken(),
          },
          body: formData,
        });

        if (response.ok) {
          let data = await response.json();
          if (data.lastChunk) {
            listenForUpdates();
          }
        } else {
          console.log(response);
          setMess("An error occurred while uploading File.");
          setLoader(false);
          setPer(null);
          return;
        }
      }
    } catch (error) {
      logToServer("error", `Error uploading file: ${error}`);
      setMess("An error occurred while uploading the file.");
      setLoader(false);
      setPer(false);
    }
  };

  const handleFinalResponse = (data) => {
    setPer(false);
    if (data["message"] === "success") {
      setMess("Layer created successfully");
      setName(data["name"]);
      setBounds(data["bounds"]);
      setPath(data["path"]);
      setType(data["type"]);
      setParent(data["parent"]);
      SetAdd(true);
      setFill(false);
      setColor(null);
      setCsv(false);

      setGeoLayerName(data["name"]);
      setGeoWorkspace("useruploads");

      let existingPaths = sessionStorage.getItem("path");
      if (existingPaths) {
        existingPaths = JSON.parse(existingPaths);
        deletePath(existingPaths);
      }

      sessionStorage.setItem("path", JSON.stringify([data["path"]]));
      logToServer("info", "Layer created successfully");
    } else if (data["message"] === "csv") {
      setColumn(data.csv_content);
      setfile_path(data.file_path);
      setCsv(true);
    } else if (data["message"] === "sld") {
      if (data["status"]) {
        setMess("SLD uploaded successfully");
      } else {
        setMess("SLD was not uploaded");
      }
      SetAdd(false);
      setCsv(false);
    } else {
      setMess("Layer was not created.");
      logToServer("error", "Layer was not created.");
      SetAdd(false);
      setCsv(false);
    }
  };

  // hide content on click anyshwre on screen
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#upload") &&
        toolvisRef.current &&
        !toolvisRef.current.contains(event.target)
      ) {
        setshow(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // edited by Amit

  const handleLongitudeChange = (e) => {
    setLongitude(e.target.value);
  };
  const handleLatitudeChange = (e) => {
    setLatitude(e.target.value);
  };

  const handleclick2 = async () => {
    if (!latitude || !longitude) {
      alert("Please select Latitude and Longitude columns.");
      return;
    }
    const latitudeIndex = column.indexOf(latitude);
    const longitudeIndex = column.indexOf(longitude);

    // console.log(file);
    // console.log(file_path);
    const formData = new FormData();
    formData.append("path", file_path);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);

    setLoader(true);
    try {
      const response = await fetch(`${HOST}/upload_csv`, {
        method: "POST",
        credentials: "include",
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        if (data["message"] === "success") {
          setMess("Layer created successfully");
          setName(data["name"]);
          setBounds(data["bounds"]);
          setPath(data["path"]);
          setType(data["type"]);
          setParent(data["parent"]);
          SetAdd(true);
          setFill(false);
          setColor(null);
          setCsv(false);
          setLoader(false);
          logToServer("info", "Layer was created Successfully");
        } else {
          setLoader(false);
          logToServer("error", "Failed Layer was not Create");
          alert("Layer was not created.");
        }
      } else {
        setLoader(false);
        alert("Failed to upload file.");
        logToServer("error", "Failed to upload File");
      }
    } catch (error) {
      logToServer("error", `Error uploading file:${error}`);
    }
  };

 return (
  <div style={{ position: vis ? "absolute" : "relative" }} className="toolscont">
    
    {/* ── Trigger Button ── */}
    <button
      title="Upload"
      className="btn text-white"
      id="upload"
      onClick={() => setshow((prev) => !prev)}
      style={{
        zIndex: "1000", fontSize: "15px", backgroundColor: "black",
        padding: "2px", width: "40px", height: "40px",
        borderRadius: "50%", border: "none", 
      }}
    >
      <i className="fa-solid fa-upload"></i>
    </button>

    {show && (
      <div ref={toolvisRef} className="toolsvis" id="toolvis"
        style={{ width: "260px", padding: "10px 12px" }}
      >

        {/* ── Header ── */}
        <div style={{
          display: "flex", justifyContent: "space-between", alignItems: "center",
          paddingBottom: "8px", marginBottom: "10px",
          borderBottom: "1px solid rgba(255,255,255,0.12)"
        }}>
          <span style={{ color: "#ccc", fontSize: "13px", fontWeight: 600 }}>
            <i className="fa-solid fa-upload" style={{ marginRight: "6px", fontSize: "11px" }}></i>
            Upload Layer
          </span>
          <span
            onClick={() => setshow(false)}
            style={{ color: "#e74c3c", fontSize: "20px", cursor: "pointer", lineHeight: 1 }}
          >
            &times;
          </span>
        </div>

        {/* ── File Input ── */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <input
            className="form-control custom-select"
            type="file"
            accept=".zip,.tif,.tiff,.geotiff,.kml,.kmz,.csv,.geojson,.sld"
            onChange={handleFileChange}
            style={{
              flex: 1, fontSize: "11px", padding: "4px 6px",
              backgroundColor: "transparent",
              border: "1px solid rgba(255,255,255,0.2)",
              color: "white", borderRadius: "4px",
            }}
          />
          <i
            className="fa-solid fa-circle-info"
            onClick={toggleModal}
            title="Supported: .zip (shp), .geojson, .tif, .tiff, .geotiff, .kml, .kmz, .csv, .sld"
            style={{ fontSize: "15px", color: "#7fb3f5", cursor: "pointer", flexShrink: 0 }}
          />
        </div>

        {/* ── Format hint ── */}
        {showModal && (
          <p style={{
            margin: "6px 0 0", fontSize: "10px",
            color: "rgba(255,255,255,0.45)", lineHeight: 1.5
          }}>
            .zip (shp) · .geojson · .tif · .tiff · .kml · .kmz · .csv · .sld
          </p>
        )}

        {/* ── CSV Column Selectors ── */}
        {column && column.length && csv ? (
          <div style={{ marginTop: "10px" }}>
            <p style={{ fontSize: "11px", color: "#aaa", marginBottom: "6px" }}>
              Select columns for Latitude &amp; Longitude
            </p>
            <select
              value={longitude}
              onChange={handleLongitudeChange}
              className="form-control"
              style={{ fontSize: "12px", marginBottom: "6px", backgroundColor: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.2)" }}
            >
              <option value="">Select Latitude</option>
              {column.map((name) => <option key={name} value={name}>{name}</option>)}
            </select>
            <select
              value={latitude}
              onChange={handleLatitudeChange}
              className="form-control"
              style={{ fontSize: "12px", backgroundColor: "transparent", color: "white", border: "1px solid rgba(255,255,255,0.2)" }}
            >
              <option value="">Select Longitude</option>
              {column.map((name) => <option key={name} value={name}>{name}</option>)}
            </select>
          </div>
        ) : null}

        {/* ── Upload Button ── */}
        <button
          className="btn btn-primary border-0 "
          style={{ width: "100%", fontSize: "12px", marginTop: "10px" }}
          onClick={csv ? handleclick2 : handleUpload}
        >
          Upload Layer
        </button>

        {/* ── Status message ── */}
        {mess && (
          <p style={{ margin: "6px 2px 0", fontSize: "11px", color: "#5bc0de" }}>{mess}</p>
        )}

        {/* ── Loader ── */}
        {loader && (
          <div style={{ marginTop: "10px", textAlign: "center" }}>
            <div className="lds-dual-ring">
              <i className="fa-solid fa-globe"></i>
            </div>
            {per !== null && per !== false && (
  <p style={{ fontSize: "11px", color: "#aaa", marginTop: "4px" }}>Progress: {per}%</p>
)}


          </div>
        )}

        {/* ── Post-upload options ── */}
        {add && (
          <div style={{
            marginTop: "10px", paddingTop: "10px",
            borderTop: "1px solid rgba(255,255,255,0.12)",
            display: "flex", flexDirection: "column", gap: "8px"
          }}>

            {/* Color + Fill (vector only) */}
            {type === "vector" && (
              <>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <input type="color" id="color" onChange={(e) => setColor(e.target.value)} name="color"
                    style={{ width: "28px", height: "28px", border: "none", cursor: "pointer", borderRadius: "4px" }}
                  />
                  <label htmlFor="color" style={{ fontSize: "12px", color: "white", margin: 0 }}>Select Color</label>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <input type="checkbox" id="fill" onChange={(e) => setFill(e.target.checked)} name="fill" />
                  <label htmlFor="fill" style={{ fontSize: "12px", color: "white", margin: 0 }}>Fill</label>
                </div>
              </>
            )}

            {/* Layer name */}
            <input
              className="form-control"
              type="text"
              id="name"
              onChange={(e) => setId(e.target.value)}
              name="name"
              placeholder="Enter Layer Name"
              style={{
                fontSize: "12px", height: "30px",
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.2)",
                color: "white", borderRadius: "4px",
              }}
            />

            {/* Add to project checkbox */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <input type="checkbox" id="pro" name="userType" value="pro" onChange={() => setPro(!aPro)} />
              <label htmlFor="pro" style={{ fontSize: "12px", color: "white", margin: 0 }}>Add to a project</label>
            </div>

            {/* Project selector */}
            {aPro && (
              <select
                className="dropdown-select custom-select"
                value={pro}
                onChange={(e) => setSelPro(e.target.value)}
                style={{
                  fontSize: "12px", padding: "4px",
                  backgroundColor: "transparent",
                  border: "1px solid rgba(255,255,255,0.2)",
                  color: "white", borderRadius: "4px",
                }}
              >
                <option value="">Select a Project</option>
                {userProjects?.map((p) =>
                  !exclude.includes(p.name) && <option key={p.id} value={p.id}>{p.name}</option>
                )}
                {userInfo.is_admin && organizationProjects?.map((p) =>
                  !exclude.includes(p.name) && <option key={p.id} value={p.id}>{p.name}</option>
                )}
              </select>
            )}

            {/* Add Layer button */}
            <button
              className="btn btn-primary border-0"
              style={{ width: "100%", height: "30px", fontSize: "12px" }}
              onClick={AddLayer}
            >
              Add Layer
            </button>
          </div>
        )}

      </div>
    )}
  </div>
);
}

export default Upload;
